import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".blog-slider")) return;

  let blogSlider = new Splide(".blog-slider", {
    type: "loop",
    perPage: 1,
    perMove: 1,
    arrows: false,
    pagination: false,
    gap: "1rem",
    mediaQuery: "min",
    breakpoints: {
      768: {
        perPage: 2,
      },
      992: {
        perPage: 3,
      },
    },
  });
  blogSlider.mount();
});
